import { render, staticRenderFns } from "./FullQsa.vue?vue&type=template&id=14f963b8&"
import script from "./FullQsa.vue?vue&type=script&lang=ts&"
export * from "./FullQsa.vue?vue&type=script&lang=ts&"
import style0 from "./FullQsa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports